import moment from "moment";
import i18n from "@/i18n";


const getDayName = (date: string) => {
  const translate = i18n.global.t;

  const comparisonDate = moment(date);
  const currentDate = moment();
  if (currentDate.isSame(comparisonDate, "day")) {
    return translate("notification.hariIni");
  }
  if (currentDate.subtract(1, "days").isSame(comparisonDate, "day")) {
    return translate("notification.kemarin");
  }

  return comparisonDate.format("DD-MM-YYYY");
};
export default getDayName;
